<span *ngIf="value" class="reader-only">Yes</span>
<span *ngIf="!value" class="reader-only">No</span>
<mat-icon *ngIf="value" class="state-true">check</mat-icon>
<mat-icon *ngIf="!value" class="state-false">close</mat-icon>
